module.exports = __webpack_public_path__ + "static/media/w_thunder_rainy.ee5f23da.svg";